<template>
    <div class="user-lists-modal update-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="currentList">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Title -->
            <h2>Update List</h2>

            <!-- Form -->
            <form v-if="form" :action="`${currentList.user.username}/lists/${currentList.id}`" method="post" @submit.prevent="submit">

                <!-- Name -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="list-name">Name*</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field ">
                            <input type="text"
                                   id="list-name"
                                   name="list-name"
                                   placeholder='Like "Favorite Palm Springs Eats" or "Road Trip Planning"'
                                   required
                                   class="required"
                                   v-model="form.name">
                        </div>
                        <div class="error" v-if="form.errors.name" v-text="form.errors.name"></div>
                    </div>
                </div>

                <!-- Description -->
                <div class="form__row">
                    <div class="form__row__left">
                        <label for="description">Description</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field ">
                            <textarea style="resize: none;"
                                      id="description"
                                      rows="5"
                                      v-model="form.description"
                                      name="description"
                                      placeholder="Add some notes">
                            </textarea>
                        </div>
                        <div class="error" v-if="form.errors.description" v-text="form.errors.description"></div>
                    </div>
                </div>

                <!-- Trip Days -->
                <div class="form__row form__date">
                    <div class="form__row__left">
                        <label for="trip_dates">Trip Dates</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field">
                            <input type="text"
                                   style="cursor: pointer"
                                   @click="selectDates('open-update-list-dialog')"
                                   placeholder="Add trip dates or days (optional)" readonly :value="inputDateValue">
                            <span class="text-info">Trip dates/days are optional. Only you can see trip dates.</span>
                        </div>
                    </div>
                </div>


                <!-- Secret -->
                <div class="form__row secret-toggle-row">
                    <div class="form__row__left">
                        <label>Secret List</label>
                    </div>
                    <div class="form__row__right">
                        <div class="form__field secret-toggle">
                            <input type="checkbox"
                                   name="secret"
                                   id="secret"
                                   v-model="form.secret" >
                            <div class="switch"><span></span></div>
                            <p style="padding: 0px; width: 60%; margin-left: 20px">If you make this list secret, only you will be able to see it.</p>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Updating' : 'Update List' }}
                        <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>

import Form from "@/classes/Form"
import Helpers from "@/mixins/Helpers"
import TripDates from "@/mixins/TripDates"
import TripDateSelector from "./TripDateSelector"

export default {

    props: ['list'],

    mixins:[Helpers, TripDates],

    components: {
        TripDateSelector
    },

    data() {
        return {
            currentList: this.list,
            form: null
        }
    },

    created() {
        this.createForm()
        eventBus.$on('open-update-list-dialog', event => {
            this.form.trip_date = event.trip_date
            this.form.trip_days = event.trip_days
            this.openModal()
        });
        eventBus.$on('open-update-list-modal', list => {
            this.currentList = list
            this.createForm()
            this.openModal()
        });
    },

    methods: {

        submit() {
            this.form.patch(`/${this.currentList.user.username}/lists/${this.currentList.id}`)
                .then(response => {
                    eventBus.$emit('list-updated', response)
                    this.closeModal()
                })
                .catch(errors => {
                    console.error(errors)
                })
        },

        createForm() {

            if (!this.currentList) {
                return
            }

            this.form = new Form({
                name: this.currentList.name,
                description: this.currentList.description,
                secret: this.currentList.secret,
                trip_date: this.currentList.trip_date,
                trip_days: this.currentList.trip_days,
            }).dontClear()
        },

        openModal() {
            $('.update-list-dialog').fadeIn()
            let timeout = setTimeout(() => {
                document.body.classList.add('no-scroll')
                clearTimeout(timeout)
            }, 500)
        },

        closeModal() {
            document.body.classList.remove('no-scroll')
            $('.update-list-dialog').fadeOut();
        },
    },
}
</script>
